var map = {
	"./assignments/en/MolarityDensity/dilution/assignment.json": 44276,
	"./assignments/en/MolarityDensity/dilution/configuration.json": 20339,
	"./assignments/en/MolarityDensity/dilution/reactions.json": 92556,
	"./assignments/en/MolarityDensity/dilution/solutions.json": 62523,
	"./assignments/en/MolarityDensity/dilution/species.json": 65276,
	"./assignments/en/MolarityDensity/dilution/spectra.json": 41076,
	"./assignments/en/MolarityDensity/sucrose/assignment.json": 93620,
	"./assignments/en/MolarityDensity/sucrose/configuration.json": 38654,
	"./assignments/en/MolarityDensity/sucrose/reactions.json": 9485,
	"./assignments/en/MolarityDensity/sucrose/solutions.json": 41332,
	"./assignments/en/MolarityDensity/sucrose/species.json": 46331,
	"./assignments/en/MolarityDensity/sucrose/spectra.json": 66199,
	"./assignments/en/Redox/redox/assignment.json": 85525,
	"./assignments/en/Redox/redox/configuration.json": 23671,
	"./assignments/en/Redox/redox/reactions.json": 79286,
	"./assignments/en/Redox/redox/solutions.json": 36943,
	"./assignments/en/Redox/redox/species.json": 10353,
	"./assignments/en/Redox/redox/spectra.json": 44839,
	"./assignments/en/Redox/redox2/assignment.json": 87743,
	"./assignments/en/Redox/redox2/configuration.json": 56139,
	"./assignments/en/Redox/redox2/reactions.json": 12731,
	"./assignments/en/Redox/redox2/solutions.json": 42893,
	"./assignments/en/Redox/redox2/species.json": 76999,
	"./assignments/en/Redox/redox2/spectra.json": 77669,
	"./assignments/en/chem207/exp01/assignment.json": 76380,
	"./assignments/en/chem207/exp01/configuration.json": 15476,
	"./assignments/en/chem207/exp01/reactions.json": 14933,
	"./assignments/en/chem207/exp01/solutions.json": 60905,
	"./assignments/en/chem207/exp01/species.json": 92663,
	"./assignments/en/chem207/exp01/spectra.json": 60941,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/assignment.json": 97823,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/configuration.json": 31718,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/reactions.json": 57264,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/solutions.json": 24807,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/species.json": 28286,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/spectra.json": 61966,
	"./assignments/en/chemvlab/IV/IV_iodine_12/assignment.json": 77242,
	"./assignments/en/chemvlab/IV/IV_iodine_12/configuration.json": 23591,
	"./assignments/en/chemvlab/IV/IV_iodine_12/reactions.json": 6288,
	"./assignments/en/chemvlab/IV/IV_iodine_12/solutions.json": 92977,
	"./assignments/en/chemvlab/IV/IV_iodine_12/species.json": 66699,
	"./assignments/en/chemvlab/IV/IV_iodine_12/spectra.json": 72065,
	"./assignments/en/chemvlab/IV/IV_iodine_18/assignment.json": 54129,
	"./assignments/en/chemvlab/IV/IV_iodine_18/configuration.json": 27150,
	"./assignments/en/chemvlab/IV/IV_iodine_18/reactions.json": 76516,
	"./assignments/en/chemvlab/IV/IV_iodine_18/solutions.json": 91013,
	"./assignments/en/chemvlab/IV/IV_iodine_18/species.json": 72050,
	"./assignments/en/chemvlab/IV/IV_iodine_18/spectra.json": 12385,
	"./assignments/en/chemvlab/IV/IV_make_glucose/assignment.json": 80819,
	"./assignments/en/chemvlab/IV/IV_make_glucose/configuration.json": 21936,
	"./assignments/en/chemvlab/IV/IV_make_glucose/reactions.json": 97471,
	"./assignments/en/chemvlab/IV/IV_make_glucose/solutions.json": 5501,
	"./assignments/en/chemvlab/IV/IV_make_glucose/species.json": 68431,
	"./assignments/en/chemvlab/IV/IV_make_glucose/spectra.json": 64406,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/assignment.json": 21353,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/configuration.json": 8481,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/reactions.json": 97880,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/solutions.json": 87556,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/species.json": 64923,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/spectra.json": 65254,
	"./assignments/en/chemvlab/IV/IV_make_saline/assignment.json": 14331,
	"./assignments/en/chemvlab/IV/IV_make_saline/configuration.json": 33323,
	"./assignments/en/chemvlab/IV/IV_make_saline/reactions.json": 2151,
	"./assignments/en/chemvlab/IV/IV_make_saline/solutions.json": 95343,
	"./assignments/en/chemvlab/IV/IV_make_saline/species.json": 54969,
	"./assignments/en/chemvlab/IV/IV_make_saline/spectra.json": 56716,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/assignment.json": 63514,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/configuration.json": 39930,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/reactions.json": 50692,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/solutions.json": 44313,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/species.json": 47435,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/spectra.json": 82012,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/assignment.json": 2898,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/configuration.json": 65112,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/reactions.json": 87036,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/solutions.json": 93084,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/species.json": 85345,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/spectra.json": 40031,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/assignment.json": 20422,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/configuration.json": 12278,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/reactions.json": 39723,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/solutions.json": 86960,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/species.json": 44754,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/spectra.json": 57495,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/assignment.json": 13484,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/configuration.json": 59834,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/reactions.json": 21317,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/solutions.json": 37226,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/species.json": 84243,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/spectra.json": 87985,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/assignment.json": 68210,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/configuration.json": 35108,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/reactions.json": 17291,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/solutions.json": 27481,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/species.json": 20360,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/spectra.json": 15738,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/assignment.json": 98609,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/configuration.json": 78792,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/reactions.json": 47949,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/solutions.json": 77464,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/species.json": 63942,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/spectra.json": 18358,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/assignment.json": 76187,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/configuration.json": 63751,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/reactions.json": 42801,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/solutions.json": 62318,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/species.json": 84221,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/spectra.json": 74326,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/assignment.json": 59618,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/configuration.json": 27847,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/reactions.json": 12310,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/solutions.json": 23286,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/species.json": 99780,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/spectra.json": 70139,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/assignment.json": 77463,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/configuration.json": 85597,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/reactions.json": 8386,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/solutions.json": 87004,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/species.json": 9102,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/spectra.json": 63697,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/assignment.json": 86598,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/configuration.json": 82839,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/reactions.json": 81152,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/solutions.json": 77406,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/species.json": 61285,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/spectra.json": 92327,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/assignment.json": 35024,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/configuration.json": 7320,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/reactions.json": 6971,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/solutions.json": 88718,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/species.json": 35776,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/spectra.json": 90260,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/assignment.json": 68847,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/configuration.json": 60316,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/reactions.json": 76970,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/solutions.json": 94765,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/species.json": 99199,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/spectra.json": 37442,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/assignment.json": 74941,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/configuration.json": 51675,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/reactions.json": 48641,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/solutions.json": 46126,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/species.json": 86530,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/spectra.json": 48067,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/assignment.json": 37178,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/configuration.json": 6196,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/reactions.json": 38377,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/solutions.json": 92413,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/species.json": 94431,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/spectra.json": 48230,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/assignment.json": 24252,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/configuration.json": 11137,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/reactions.json": 24284,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/solutions.json": 92905,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/species.json": 65724,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/spectra.json": 18235,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/assignment.json": 7377,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/configuration.json": 54899,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/reactions.json": 83962,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/solutions.json": 23506,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/species.json": 59276,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/spectra.json": 70741,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/assignment.json": 50094,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/configuration.json": 5401,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/reactions.json": 32922,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/solutions.json": 26551,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/species.json": 65643,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/spectra.json": 7830,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/assignment.json": 76157,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/configuration.json": 34780,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/reactions.json": 11034,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/solutions.json": 58076,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/species.json": 79900,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/spectra.json": 21796,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/assignment.json": 50284,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/configuration.json": 21741,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/reactions.json": 69503,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/solutions.json": 71198,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/species.json": 95416,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/spectra.json": 59000,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/assignment.json": 3565,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/configuration.json": 94519,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/reactions.json": 88179,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/solutions.json": 60009,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/species.json": 26846,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/spectra.json": 97624,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/assignment.json": 4636,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/configuration.json": 85186,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/reactions.json": 6528,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/solutions.json": 52262,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/species.json": 49153,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/spectra.json": 75572,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/assignment.json": 84858,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/configuration.json": 785,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/reactions.json": 62100,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/solutions.json": 92252,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/species.json": 85886,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/spectra.json": 4111,
	"./assignments/en/chemvlab/thermodynamics/Solar1/assignment.json": 22332,
	"./assignments/en/chemvlab/thermodynamics/Solar1/configuration.json": 63490,
	"./assignments/en/chemvlab/thermodynamics/Solar1/reactions.json": 1317,
	"./assignments/en/chemvlab/thermodynamics/Solar1/solutions.json": 19585,
	"./assignments/en/chemvlab/thermodynamics/Solar1/species.json": 9817,
	"./assignments/en/chemvlab/thermodynamics/Solar1/spectra.json": 26676,
	"./assignments/en/chemvlab/thermodynamics/Solar2/assignment.json": 48307,
	"./assignments/en/chemvlab/thermodynamics/Solar2/configuration.json": 11589,
	"./assignments/en/chemvlab/thermodynamics/Solar2/reactions.json": 49351,
	"./assignments/en/chemvlab/thermodynamics/Solar2/solutions.json": 63029,
	"./assignments/en/chemvlab/thermodynamics/Solar2/species.json": 34216,
	"./assignments/en/chemvlab/thermodynamics/Solar2/spectra.json": 91005,
	"./assignments/en/chemvlab/thermodynamics/Swim1/assignment.json": 18364,
	"./assignments/en/chemvlab/thermodynamics/Swim1/configuration.json": 97570,
	"./assignments/en/chemvlab/thermodynamics/Swim1/reactions.json": 93138,
	"./assignments/en/chemvlab/thermodynamics/Swim1/solutions.json": 72631,
	"./assignments/en/chemvlab/thermodynamics/Swim1/species.json": 58692,
	"./assignments/en/chemvlab/thermodynamics/Swim1/spectra.json": 38784,
	"./assignments/en/chemvlab/thermodynamics/Swim2/assignment.json": 60689,
	"./assignments/en/chemvlab/thermodynamics/Swim2/configuration.json": 613,
	"./assignments/en/chemvlab/thermodynamics/Swim2/reactions.json": 99836,
	"./assignments/en/chemvlab/thermodynamics/Swim2/solutions.json": 16439,
	"./assignments/en/chemvlab/thermodynamics/Swim2/species.json": 30219,
	"./assignments/en/chemvlab/thermodynamics/Swim2/spectra.json": 75918,
	"./assignments/en/chemvlab/thermodynamics/Swim3/assignment.json": 97762,
	"./assignments/en/chemvlab/thermodynamics/Swim3/configuration.json": 58010,
	"./assignments/en/chemvlab/thermodynamics/Swim3/reactions.json": 4421,
	"./assignments/en/chemvlab/thermodynamics/Swim3/solutions.json": 94216,
	"./assignments/en/chemvlab/thermodynamics/Swim3/species.json": 64137,
	"./assignments/en/chemvlab/thermodynamics/Swim3/spectra.json": 99376,
	"./assignments/en/chemvlab/thermodynamics/Swim4/assignment.json": 29149,
	"./assignments/en/chemvlab/thermodynamics/Swim4/configuration.json": 90388,
	"./assignments/en/chemvlab/thermodynamics/Swim4/reactions.json": 52644,
	"./assignments/en/chemvlab/thermodynamics/Swim4/solutions.json": 99236,
	"./assignments/en/chemvlab/thermodynamics/Swim4/species.json": 69131,
	"./assignments/en/chemvlab/thermodynamics/Swim4/spectra.json": 65499,
	"./assignments/en/chemvlab/thermodynamics/Swim5/assignment.json": 29111,
	"./assignments/en/chemvlab/thermodynamics/Swim5/configuration.json": 41157,
	"./assignments/en/chemvlab/thermodynamics/Swim5/reactions.json": 72328,
	"./assignments/en/chemvlab/thermodynamics/Swim5/solutions.json": 92779,
	"./assignments/en/chemvlab/thermodynamics/Swim5/species.json": 45519,
	"./assignments/en/chemvlab/thermodynamics/Swim5/spectra.json": 52176,
	"./assignments/en/chemvlab/thermodynamics/Swim6/assignment.json": 94651,
	"./assignments/en/chemvlab/thermodynamics/Swim6/configuration.json": 97632,
	"./assignments/en/chemvlab/thermodynamics/Swim6/reactions.json": 19678,
	"./assignments/en/chemvlab/thermodynamics/Swim6/solutions.json": 78255,
	"./assignments/en/chemvlab/thermodynamics/Swim6/species.json": 79475,
	"./assignments/en/chemvlab/thermodynamics/Swim6/spectra.json": 43572,
	"./assignments/en/chemvlab/thermodynamics/Swim7/assignment.json": 12882,
	"./assignments/en/chemvlab/thermodynamics/Swim7/configuration.json": 8700,
	"./assignments/en/chemvlab/thermodynamics/Swim7/reactions.json": 23211,
	"./assignments/en/chemvlab/thermodynamics/Swim7/solutions.json": 92504,
	"./assignments/en/chemvlab/thermodynamics/Swim7/species.json": 22856,
	"./assignments/en/chemvlab/thermodynamics/Swim7/spectra.json": 13201,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/assignment.json": 12281,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/configuration.json": 72858,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/reactions.json": 37848,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/solutions.json": 92900,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/species.json": 75282,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/spectra.json": 20601,
	"./assignments/en/colligative/bp_elevation/assignment.json": 92797,
	"./assignments/en/colligative/bp_elevation/configuration.json": 7271,
	"./assignments/en/colligative/bp_elevation/reactions.json": 23121,
	"./assignments/en/colligative/bp_elevation/solutions.json": 2891,
	"./assignments/en/colligative/bp_elevation/species.json": 37483,
	"./assignments/en/colligative/bp_elevation/spectra.json": 33607,
	"./assignments/en/colligative/vapor_pressure/assignment.json": 17647,
	"./assignments/en/colligative/vapor_pressure/configuration.json": 51151,
	"./assignments/en/colligative/vapor_pressure/reactions.json": 4177,
	"./assignments/en/colligative/vapor_pressure/solutions.json": 49722,
	"./assignments/en/colligative/vapor_pressure/species.json": 65645,
	"./assignments/en/colligative/vapor_pressure/spectra.json": 89851,
	"./assignments/en/default/assignment.json": 96627,
	"./assignments/en/default/configuration.json": 51904,
	"./assignments/en/default/reactions.json": 15681,
	"./assignments/en/default/solutions.json": 98205,
	"./assignments/en/default/species.json": 81422,
	"./assignments/en/default/spectra.json": 36563,
	"./assignments/en/hotcoldpack/assignment.json": 84577,
	"./assignments/en/hotcoldpack/configuration.json": 97923,
	"./assignments/en/hotcoldpack/reactions.json": 90049,
	"./assignments/en/hotcoldpack/solutions.json": 58930,
	"./assignments/en/hotcoldpack/species.json": 36173,
	"./assignments/en/hotcoldpack/spectra.json": 23711,
	"./assignments/en/iron_thiocyanate/assignment.json": 80416,
	"./assignments/en/iron_thiocyanate/configuration.json": 39375,
	"./assignments/en/iron_thiocyanate/reactions.json": 81212,
	"./assignments/en/iron_thiocyanate/solutions.json": 84948,
	"./assignments/en/iron_thiocyanate/species.json": 41615,
	"./assignments/en/iron_thiocyanate/spectra.json": 54947,
	"./assignments/en/kinetics/cv_bleaching/assignment.json": 27733,
	"./assignments/en/kinetics/cv_bleaching/configuration.json": 42897,
	"./assignments/en/kinetics/cv_bleaching/reactions.json": 82169,
	"./assignments/en/kinetics/cv_bleaching/solutions.json": 69249,
	"./assignments/en/kinetics/cv_bleaching/species.json": 98955,
	"./assignments/en/kinetics/cv_bleaching/spectra.json": 8793,
	"./assignments/en/kinetics/iodide_persulfate/assignment.json": 40707,
	"./assignments/en/kinetics/iodide_persulfate/configuration.json": 27995,
	"./assignments/en/kinetics/iodide_persulfate/reactions.json": 9200,
	"./assignments/en/kinetics/iodide_persulfate/solutions.json": 9777,
	"./assignments/en/kinetics/iodide_persulfate/species.json": 86411,
	"./assignments/en/kinetics/iodide_persulfate/spectra.json": 10831,
	"./assignments/en/kinetics/k1/assignment.json": 51417,
	"./assignments/en/kinetics/k1/configuration.json": 78089,
	"./assignments/en/kinetics/k1/reactions.json": 12126,
	"./assignments/en/kinetics/k1/solutions.json": 38132,
	"./assignments/en/kinetics/k1/species.json": 34984,
	"./assignments/en/kinetics/k1/spectra.json": 38679,
	"./assignments/en/kinetics/k2/assignment.json": 43731,
	"./assignments/en/kinetics/k2/configuration.json": 17448,
	"./assignments/en/kinetics/k2/reactions.json": 11921,
	"./assignments/en/kinetics/k2/solutions.json": 92645,
	"./assignments/en/kinetics/k2/species.json": 85859,
	"./assignments/en/kinetics/k2/spectra.json": 68388,
	"./assignments/en/kinetics/k3/assignment.json": 29870,
	"./assignments/en/kinetics/k3/configuration.json": 26595,
	"./assignments/en/kinetics/k3/reactions.json": 22655,
	"./assignments/en/kinetics/k3/solutions.json": 99761,
	"./assignments/en/kinetics/k3/species.json": 3544,
	"./assignments/en/kinetics/k3/spectra.json": 25389,
	"./assignments/en/kinetics/k4equilibrium/assignment.json": 35303,
	"./assignments/en/kinetics/k4equilibrium/configuration.json": 64936,
	"./assignments/en/kinetics/k4equilibrium/reactions.json": 3018,
	"./assignments/en/kinetics/k4equilibrium/solutions.json": 50108,
	"./assignments/en/kinetics/k4equilibrium/species.json": 59584,
	"./assignments/en/kinetics/k4equilibrium/spectra.json": 75500,
	"./assignments/en/metals/assignment.json": 89622,
	"./assignments/en/metals/configuration.json": 88180,
	"./assignments/en/metals/reactions.json": 68245,
	"./assignments/en/metals/solutions.json": 28555,
	"./assignments/en/metals/species.json": 56743,
	"./assignments/en/metals/spectra.json": 45231,
	"./assignments/en/solubility/assignment.json": 93729,
	"./assignments/en/solubility/configuration.json": 87466,
	"./assignments/en/solubility/reactions.json": 99141,
	"./assignments/en/solubility/solutions.json": 50969,
	"./assignments/en/solubility/species.json": 73686,
	"./assignments/en/solubility/spectra.json": 82219,
	"./assignments/en/test/assignment.json": 68637,
	"./assignments/en/test/configuration.json": 71716,
	"./assignments/en/test/reactions.json": 66546,
	"./assignments/en/test/solutions.json": 80896,
	"./assignments/en/test/species.json": 33281,
	"./assignments/en/test/spectra.json": 14598,
	"./assignments/es/default/assignment.json": 70268,
	"./assignments/es/default/configuration.json": 19406,
	"./assignments/es/default/reactions.json": 90370,
	"./assignments/es/default/solutions.json": 67,
	"./assignments/es/default/species.json": 76584,
	"./assignments/es/default/spectra.json": 96588,
	"./assignments_chemv_en.json": 74148,
	"./assignments_en.json": 33406,
	"./assignments_es.json": 80202,
	"resources/assignments/en/MolarityDensity/dilution/assignment.json": 44276,
	"resources/assignments/en/MolarityDensity/dilution/configuration.json": 20339,
	"resources/assignments/en/MolarityDensity/dilution/reactions.json": 92556,
	"resources/assignments/en/MolarityDensity/dilution/solutions.json": 62523,
	"resources/assignments/en/MolarityDensity/dilution/species.json": 65276,
	"resources/assignments/en/MolarityDensity/dilution/spectra.json": 41076,
	"resources/assignments/en/MolarityDensity/sucrose/assignment.json": 93620,
	"resources/assignments/en/MolarityDensity/sucrose/configuration.json": 38654,
	"resources/assignments/en/MolarityDensity/sucrose/reactions.json": 9485,
	"resources/assignments/en/MolarityDensity/sucrose/solutions.json": 41332,
	"resources/assignments/en/MolarityDensity/sucrose/species.json": 46331,
	"resources/assignments/en/MolarityDensity/sucrose/spectra.json": 66199,
	"resources/assignments/en/Redox/redox/assignment.json": 85525,
	"resources/assignments/en/Redox/redox/configuration.json": 23671,
	"resources/assignments/en/Redox/redox/reactions.json": 79286,
	"resources/assignments/en/Redox/redox/solutions.json": 36943,
	"resources/assignments/en/Redox/redox/species.json": 10353,
	"resources/assignments/en/Redox/redox/spectra.json": 44839,
	"resources/assignments/en/Redox/redox2/assignment.json": 87743,
	"resources/assignments/en/Redox/redox2/configuration.json": 56139,
	"resources/assignments/en/Redox/redox2/reactions.json": 12731,
	"resources/assignments/en/Redox/redox2/solutions.json": 42893,
	"resources/assignments/en/Redox/redox2/species.json": 76999,
	"resources/assignments/en/Redox/redox2/spectra.json": 77669,
	"resources/assignments/en/chem207/exp01/assignment.json": 76380,
	"resources/assignments/en/chem207/exp01/configuration.json": 15476,
	"resources/assignments/en/chem207/exp01/reactions.json": 14933,
	"resources/assignments/en/chem207/exp01/solutions.json": 60905,
	"resources/assignments/en/chem207/exp01/species.json": 92663,
	"resources/assignments/en/chem207/exp01/spectra.json": 60941,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/assignment.json": 97823,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/configuration.json": 31718,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/reactions.json": 57264,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/solutions.json": 24807,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/species.json": 28286,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/spectra.json": 61966,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/assignment.json": 77242,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/configuration.json": 23591,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/reactions.json": 6288,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/solutions.json": 92977,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/species.json": 66699,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/spectra.json": 72065,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/assignment.json": 54129,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/configuration.json": 27150,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/reactions.json": 76516,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/solutions.json": 91013,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/species.json": 72050,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/spectra.json": 12385,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/assignment.json": 80819,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/configuration.json": 21936,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/reactions.json": 97471,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/solutions.json": 5501,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/species.json": 68431,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/spectra.json": 64406,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/assignment.json": 21353,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/configuration.json": 8481,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/reactions.json": 97880,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/solutions.json": 87556,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/species.json": 64923,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/spectra.json": 65254,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/assignment.json": 14331,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/configuration.json": 33323,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/reactions.json": 2151,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/solutions.json": 95343,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/species.json": 54969,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/spectra.json": 56716,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/assignment.json": 63514,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/configuration.json": 39930,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/reactions.json": 50692,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/solutions.json": 44313,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/species.json": 47435,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/spectra.json": 82012,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/assignment.json": 2898,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/configuration.json": 65112,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/reactions.json": 87036,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/solutions.json": 93084,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/species.json": 85345,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/spectra.json": 40031,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/assignment.json": 20422,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/configuration.json": 12278,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/reactions.json": 39723,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/solutions.json": 86960,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/species.json": 44754,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/spectra.json": 57495,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/assignment.json": 13484,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/configuration.json": 59834,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/reactions.json": 21317,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/solutions.json": 37226,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/species.json": 84243,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/spectra.json": 87985,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/assignment.json": 68210,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/configuration.json": 35108,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/reactions.json": 17291,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/solutions.json": 27481,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/species.json": 20360,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/spectra.json": 15738,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/assignment.json": 98609,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/configuration.json": 78792,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/reactions.json": 47949,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/solutions.json": 77464,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/species.json": 63942,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/spectra.json": 18358,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/assignment.json": 76187,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/configuration.json": 63751,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/reactions.json": 42801,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/solutions.json": 62318,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/species.json": 84221,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/spectra.json": 74326,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/assignment.json": 59618,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/configuration.json": 27847,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/reactions.json": 12310,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/solutions.json": 23286,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/species.json": 99780,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/spectra.json": 70139,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/assignment.json": 77463,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/configuration.json": 85597,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/reactions.json": 8386,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/solutions.json": 87004,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/species.json": 9102,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/spectra.json": 63697,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/assignment.json": 86598,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/configuration.json": 82839,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/reactions.json": 81152,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/solutions.json": 77406,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/species.json": 61285,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/spectra.json": 92327,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/assignment.json": 35024,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/configuration.json": 7320,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/reactions.json": 6971,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/solutions.json": 88718,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/species.json": 35776,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/spectra.json": 90260,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/assignment.json": 68847,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/configuration.json": 60316,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/reactions.json": 76970,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/solutions.json": 94765,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/species.json": 99199,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/spectra.json": 37442,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/assignment.json": 74941,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/configuration.json": 51675,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/reactions.json": 48641,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/solutions.json": 46126,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/species.json": 86530,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/spectra.json": 48067,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/assignment.json": 37178,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/configuration.json": 6196,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/reactions.json": 38377,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/solutions.json": 92413,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/species.json": 94431,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/spectra.json": 48230,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/assignment.json": 24252,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/configuration.json": 11137,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/reactions.json": 24284,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/solutions.json": 92905,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/species.json": 65724,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/spectra.json": 18235,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/assignment.json": 7377,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/configuration.json": 54899,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/reactions.json": 83962,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/solutions.json": 23506,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/species.json": 59276,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/spectra.json": 70741,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/assignment.json": 50094,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/configuration.json": 5401,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/reactions.json": 32922,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/solutions.json": 26551,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/species.json": 65643,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/spectra.json": 7830,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/assignment.json": 76157,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/configuration.json": 34780,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/reactions.json": 11034,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/solutions.json": 58076,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/species.json": 79900,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/spectra.json": 21796,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/assignment.json": 50284,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/configuration.json": 21741,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/reactions.json": 69503,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/solutions.json": 71198,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/species.json": 95416,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/spectra.json": 59000,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/assignment.json": 3565,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/configuration.json": 94519,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/reactions.json": 88179,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/solutions.json": 60009,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/species.json": 26846,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/spectra.json": 97624,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/assignment.json": 4636,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/configuration.json": 85186,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/reactions.json": 6528,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/solutions.json": 52262,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/species.json": 49153,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/spectra.json": 75572,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/assignment.json": 84858,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/configuration.json": 785,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/reactions.json": 62100,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/solutions.json": 92252,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/species.json": 85886,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/spectra.json": 4111,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/assignment.json": 22332,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/configuration.json": 63490,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/reactions.json": 1317,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/solutions.json": 19585,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/species.json": 9817,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/spectra.json": 26676,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/assignment.json": 48307,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/configuration.json": 11589,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/reactions.json": 49351,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/solutions.json": 63029,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/species.json": 34216,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/spectra.json": 91005,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/assignment.json": 18364,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/configuration.json": 97570,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/reactions.json": 93138,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/solutions.json": 72631,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/species.json": 58692,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/spectra.json": 38784,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/assignment.json": 60689,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/configuration.json": 613,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/reactions.json": 99836,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/solutions.json": 16439,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/species.json": 30219,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/spectra.json": 75918,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/assignment.json": 97762,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/configuration.json": 58010,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/reactions.json": 4421,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/solutions.json": 94216,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/species.json": 64137,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/spectra.json": 99376,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/assignment.json": 29149,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/configuration.json": 90388,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/reactions.json": 52644,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/solutions.json": 99236,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/species.json": 69131,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/spectra.json": 65499,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/assignment.json": 29111,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/configuration.json": 41157,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/reactions.json": 72328,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/solutions.json": 92779,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/species.json": 45519,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/spectra.json": 52176,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/assignment.json": 94651,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/configuration.json": 97632,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/reactions.json": 19678,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/solutions.json": 78255,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/species.json": 79475,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/spectra.json": 43572,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/assignment.json": 12882,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/configuration.json": 8700,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/reactions.json": 23211,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/solutions.json": 92504,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/species.json": 22856,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/spectra.json": 13201,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/assignment.json": 12281,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/configuration.json": 72858,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/reactions.json": 37848,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/solutions.json": 92900,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/species.json": 75282,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/spectra.json": 20601,
	"resources/assignments/en/colligative/bp_elevation/assignment.json": 92797,
	"resources/assignments/en/colligative/bp_elevation/configuration.json": 7271,
	"resources/assignments/en/colligative/bp_elevation/reactions.json": 23121,
	"resources/assignments/en/colligative/bp_elevation/solutions.json": 2891,
	"resources/assignments/en/colligative/bp_elevation/species.json": 37483,
	"resources/assignments/en/colligative/bp_elevation/spectra.json": 33607,
	"resources/assignments/en/colligative/vapor_pressure/assignment.json": 17647,
	"resources/assignments/en/colligative/vapor_pressure/configuration.json": 51151,
	"resources/assignments/en/colligative/vapor_pressure/reactions.json": 4177,
	"resources/assignments/en/colligative/vapor_pressure/solutions.json": 49722,
	"resources/assignments/en/colligative/vapor_pressure/species.json": 65645,
	"resources/assignments/en/colligative/vapor_pressure/spectra.json": 89851,
	"resources/assignments/en/default/assignment.json": 96627,
	"resources/assignments/en/default/configuration.json": 51904,
	"resources/assignments/en/default/reactions.json": 15681,
	"resources/assignments/en/default/solutions.json": 98205,
	"resources/assignments/en/default/species.json": 81422,
	"resources/assignments/en/default/spectra.json": 36563,
	"resources/assignments/en/hotcoldpack/assignment.json": 84577,
	"resources/assignments/en/hotcoldpack/configuration.json": 97923,
	"resources/assignments/en/hotcoldpack/reactions.json": 90049,
	"resources/assignments/en/hotcoldpack/solutions.json": 58930,
	"resources/assignments/en/hotcoldpack/species.json": 36173,
	"resources/assignments/en/hotcoldpack/spectra.json": 23711,
	"resources/assignments/en/iron_thiocyanate/assignment.json": 80416,
	"resources/assignments/en/iron_thiocyanate/configuration.json": 39375,
	"resources/assignments/en/iron_thiocyanate/reactions.json": 81212,
	"resources/assignments/en/iron_thiocyanate/solutions.json": 84948,
	"resources/assignments/en/iron_thiocyanate/species.json": 41615,
	"resources/assignments/en/iron_thiocyanate/spectra.json": 54947,
	"resources/assignments/en/kinetics/cv_bleaching/assignment.json": 27733,
	"resources/assignments/en/kinetics/cv_bleaching/configuration.json": 42897,
	"resources/assignments/en/kinetics/cv_bleaching/reactions.json": 82169,
	"resources/assignments/en/kinetics/cv_bleaching/solutions.json": 69249,
	"resources/assignments/en/kinetics/cv_bleaching/species.json": 98955,
	"resources/assignments/en/kinetics/cv_bleaching/spectra.json": 8793,
	"resources/assignments/en/kinetics/iodide_persulfate/assignment.json": 40707,
	"resources/assignments/en/kinetics/iodide_persulfate/configuration.json": 27995,
	"resources/assignments/en/kinetics/iodide_persulfate/reactions.json": 9200,
	"resources/assignments/en/kinetics/iodide_persulfate/solutions.json": 9777,
	"resources/assignments/en/kinetics/iodide_persulfate/species.json": 86411,
	"resources/assignments/en/kinetics/iodide_persulfate/spectra.json": 10831,
	"resources/assignments/en/kinetics/k1/assignment.json": 51417,
	"resources/assignments/en/kinetics/k1/configuration.json": 78089,
	"resources/assignments/en/kinetics/k1/reactions.json": 12126,
	"resources/assignments/en/kinetics/k1/solutions.json": 38132,
	"resources/assignments/en/kinetics/k1/species.json": 34984,
	"resources/assignments/en/kinetics/k1/spectra.json": 38679,
	"resources/assignments/en/kinetics/k2/assignment.json": 43731,
	"resources/assignments/en/kinetics/k2/configuration.json": 17448,
	"resources/assignments/en/kinetics/k2/reactions.json": 11921,
	"resources/assignments/en/kinetics/k2/solutions.json": 92645,
	"resources/assignments/en/kinetics/k2/species.json": 85859,
	"resources/assignments/en/kinetics/k2/spectra.json": 68388,
	"resources/assignments/en/kinetics/k3/assignment.json": 29870,
	"resources/assignments/en/kinetics/k3/configuration.json": 26595,
	"resources/assignments/en/kinetics/k3/reactions.json": 22655,
	"resources/assignments/en/kinetics/k3/solutions.json": 99761,
	"resources/assignments/en/kinetics/k3/species.json": 3544,
	"resources/assignments/en/kinetics/k3/spectra.json": 25389,
	"resources/assignments/en/kinetics/k4equilibrium/assignment.json": 35303,
	"resources/assignments/en/kinetics/k4equilibrium/configuration.json": 64936,
	"resources/assignments/en/kinetics/k4equilibrium/reactions.json": 3018,
	"resources/assignments/en/kinetics/k4equilibrium/solutions.json": 50108,
	"resources/assignments/en/kinetics/k4equilibrium/species.json": 59584,
	"resources/assignments/en/kinetics/k4equilibrium/spectra.json": 75500,
	"resources/assignments/en/metals/assignment.json": 89622,
	"resources/assignments/en/metals/configuration.json": 88180,
	"resources/assignments/en/metals/reactions.json": 68245,
	"resources/assignments/en/metals/solutions.json": 28555,
	"resources/assignments/en/metals/species.json": 56743,
	"resources/assignments/en/metals/spectra.json": 45231,
	"resources/assignments/en/solubility/assignment.json": 93729,
	"resources/assignments/en/solubility/configuration.json": 87466,
	"resources/assignments/en/solubility/reactions.json": 99141,
	"resources/assignments/en/solubility/solutions.json": 50969,
	"resources/assignments/en/solubility/species.json": 73686,
	"resources/assignments/en/solubility/spectra.json": 82219,
	"resources/assignments/en/test/assignment.json": 68637,
	"resources/assignments/en/test/configuration.json": 71716,
	"resources/assignments/en/test/reactions.json": 66546,
	"resources/assignments/en/test/solutions.json": 80896,
	"resources/assignments/en/test/species.json": 33281,
	"resources/assignments/en/test/spectra.json": 14598,
	"resources/assignments/es/default/assignment.json": 70268,
	"resources/assignments/es/default/configuration.json": 19406,
	"resources/assignments/es/default/reactions.json": 90370,
	"resources/assignments/es/default/solutions.json": 67,
	"resources/assignments/es/default/species.json": 76584,
	"resources/assignments/es/default/spectra.json": 96588,
	"resources/assignments_chemv_en.json": 74148,
	"resources/assignments_en.json": 33406,
	"resources/assignments_es.json": 80202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85285;